import { createIcon } from "@chakra-ui/icons";

export const ErrorIcon = createIcon({
  displayName: "ErrorIcon",
  viewBox: "0 0 16 16",
  path: (
    <>
      <path
        d="M8.00001 0C3.584 0 0 3.584 0 8.00001C0 12.416 3.584 16 8.00001 16C12.416 16 16 12.416 16 8.00001C16 3.584 12.416 0 8.00001 0Z"
        fill="currentColor"
      />
      <path
        d="M8.79995 11.2C8.79995 11.6418 8.44178 12 7.99995 12C7.55812 12 7.19995 11.6418 7.19995 11.2C7.19995 10.7582 7.55812 10.4 7.99995 10.4C8.44178 10.4 8.79995 10.7582 8.79995 11.2Z"
        fill="white"
      />
      <path
        d="M7.99995 8.80004C7.55995 8.80004 7.19995 8.44004 7.19995 8.00004V4.80003C7.19995 4.36003 7.55995 4.00003 7.99995 4.00003C8.43995 4.00003 8.79995 4.36003 8.79995 4.80003V8.00004C8.79995 8.44004 8.43995 8.80004 7.99995 8.80004Z"
        fill="white"
      />
      ,
    </>
  ),
  defaultProps: {
    w: "16px",
    h: "16px",
  },
});
